module.exports = __webpack_public_path__ + "media/images/prediction/bnr_prediction_dokanto-92c61a0b54d01172ff4e6f3282f657f5.png";